const formattedListCls = "_ecfdepdx8";

export { formattedListCls };
import "./formatted-list.style.linaria.module.css";
//# sourceMappingURL=formatted-list.style.js.map
